import React, { useState } from "react";
import { Skeleton } from "antd";

const GridView = ({ data, loading, config, totalRecords }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const {
    searchField = "name",
    titleField = "name",
    subtitleField = null,
    imageField = "imageUrl",
    emptyMessage = "No data found",
    extraFields = []
  } = config || {};

  const filteredData = data.filter((item) =>
    (item[searchField] || "").toString().toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="card h-100 radius-12 border-0">
      <div className="card-body">
        {loading ? (
          <div className="row gy-4">
            {[...Array(4)].map((_, key) => (
              <div key={key} className="col-xxl-3 col-md-4 col-sm-6">
                <div className="radius-10 overflow-hidden p-3 shadow-xs border">
                  <Skeleton.Image active className="w-100 mb-3" style={{ height: 200 }} />
                  <Skeleton.Input active size="small" block className="mb-1" />
                  <Skeleton.Input active size="small" block style={{ width: '60%' }} />
                </div>
              </div>
            ))}
          </div>
        ) : filteredData.length === 0 ? (
          <div className="text-center w-100 my-3 text-muted">
            {emptyMessage}
          </div>
        ) : (
          <div className="row">
          <p style={{margin:"0px 0px 10px"}}>Showing {data?.length} of {totalRecords} Records</p>
            {filteredData.map((item, key) => (
              <div key={key} className="col-xxl-3 col-md-4 col-sm-6 mb-3">
                <div className="p-3 bg-white border shadow-sm rounded-4 h-100 position-relative">
                  <div className="mb-3 d-flex align-items-center justify-content-center rounded-3 overflow-hidden" style={{ height: "120px" }}>
                    <img
                      src={item[imageField] || "/assets/images/broken-image.png"}
                      alt={item[titleField]}
                      className="img-fluid"
                    />
                  </div>
                  <div className="mb-2 d-flex justify-content-between align-items-center bg-light p-2 rounded-3 overflow-hidden">
                    <h6 className="fw-bold mb-0 text-truncate text-md" style={{ color: '#2c3e50', maxWidth: '70%' }}>
                      {item[titleField]}
                    </h6>
                    {subtitleField && (
                      <small className="text-muted text-end" style={{ whiteSpace: 'nowrap' }}>
                        {item[subtitleField] || "—"}
                      </small>
                    )}
                  </div>
                  {extraFields.length > 0 && (
                    <div className="px-2">
                      {extraFields.map((field, idx) => (
                        <div key={idx} className="d-flex justify-content-between small text-muted">
                          <span>{field.label}:</span>
                          <span>
                            {field.prefix || ''}
                            {item[field.key] ?? "—"}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GridView;